module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[7]),
      expression: "getScreenSize < 2 && !delayedLoading[7]"
    }],
    ref: "form",
    attrs: {
      "label-position": "top",
      "element-loading-text": "Loading..."
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [(_vm.$p('settings/FTPSending/address') && (_vm.getScreenSize > 1 || _vm.delayedLoading[1])) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/FTP Address')
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.getSettingsAddons.ftp == '0'
    },
    model: {
      value: (_vm.getSettingsFTPSending.address),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsFTPSending, "address", $$v)
      },
      expression: "getSettingsFTPSending.address"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/refresh') && (_vm.getScreenSize > 1 || _vm.delayedLoading[2])) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Refresh Rate')
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.getSettingsAddons.ftp == '0',
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsFTPSending.refresh),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsFTPSending, "refresh", $$v)
      },
      expression: "getSettingsFTPSending.refresh"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/FTPSending/Disable'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/FTPSending/sec'),
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '5 ' + _vm.$l('settings/FTPSending/sec'),
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/FTPSending/min'),
      "value": "60"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '5 ' + _vm.$l('settings/FTPSending/min'),
      "value": "300"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '10 ' + _vm.$l('settings/FTPSending/min'),
      "value": "600"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '15 ' + _vm.$l('settings/FTPSending/min'),
      "value": "900"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/FTPSending/hour'),
      "value": "3600"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/username') && (_vm.getScreenSize > 1 || _vm.delayedLoading[3])) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.ftp == '1'),
      expression: "getSettingsAddons.ftp == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Username')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsFTPSending.user),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsFTPSending, "user", $$v)
      },
      expression: "getSettingsFTPSending.user"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/password') && (_vm.getScreenSize > 1 || _vm.delayedLoading[4])) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.ftp == '1'),
      expression: "getSettingsAddons.ftp == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPassword ? '' : 'password'
    },
    model: {
      value: (_vm.getSettingsFTPSending.password),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsFTPSending, "password", $$v)
      },
      expression: "getSettingsFTPSending.password"
    }
  }, [_c('el-button', {
    staticClass: "show-password-button",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    slot: "append"
  }, [_c('icon', {
    attrs: {
      "name": "eye"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/port') && (_vm.getScreenSize > 1 || _vm.delayedLoading[5])) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.ftp == '1'),
      expression: "getSettingsAddons.ftp == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/FTPSending/Port')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.getSettingsFTPSending.port),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsFTPSending, "port", $$v)
      },
      expression: "getSettingsFTPSending.port"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$p('settings/FTPSending/port') && (_vm.getScreenSize > 1 || _vm.delayedLoading[6])) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.ftp == '1'),
      expression: "getSettingsAddons.ftp == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    staticClass: "test-button",
    attrs: {
      "loading": _vm.testButtonLoading,
      "type": "primary"
    },
    on: {
      "click": _vm.testButtonClicked
    }
  }, [_vm._v("Test")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col'), _vm._v(" "), (_vm.$p('settings/FTPSending/zipped') && (_vm.getScreenSize > 1 || _vm.delayedLoading[7])) ? _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getSettingsAddons.ftp == '1'),
      expression: "getSettingsAddons.ftp == '1'"
    }],
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/download/Compression')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsFTPSending.zip),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsFTPSending, "zip", $$v)
      },
      expression: "getSettingsFTPSending.zip"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/download/No compression'),
      "value": '0'
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/download/Zip compression'),
      "value": '1'
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$p('settings/FTPSending/values') && (_vm.getScreenSize > 1 || _vm.delayedLoading[7])) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/FTPSending/Values')
    }
  }, [_c('el-row', _vm._l((_vm.getSettingsFTPSending.valsel), function(item) {
    return _c('el-col', {
      key: item.name,
      attrs: {
        "md": 12,
        "lg": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": _vm.$l('settings/FTPSending/' + item.name)
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (item.enabled),
        callback: function($$v) {
          _vm.$set(item, "enabled", $$v)
        },
        expression: "item.enabled"
      }
    })], 1)], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64b6e198","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/FTPSending.vue
// module id = 462
// module chunks = 1